export const checkbox = {
  root: {
    class: [
      'relative',

      // Alignment
      'inline-flex',
      'align-bottom',

      // Size
      'w-5',
      'h-5',

      // Misc
      'cursor-pointer',
      'select-none',
    ],
  },
  box: ({ props, context }: Record<string, any>) => ({
    class: [
      // Alignment
      'flex',
      'items-center',
      'justify-center',

      // Size
      'w-5',
      'h-5',

      // Shape
      'rounded',
      'border',

      // Colors
      {
        'border-primary bg-primary': context.checked,
      },

      // Invalid State
      'invalid:focus:ring-red-200',
      'invalid:hover:border-red-500',
      { 'border-red-500': props.invalid },

      // States
      {
        'peer-focus-visible:z-10 peer-focus-visible:outline-none peer-focus-visible:outline-offset-0 peer-focus-visible:ring-1 peer-focus-visible:ring-primary-500':
          !props.disabled,
        'select-none pointer-events-none cursor-default': props.disabled,
      },

      {
        '[&>svg]:text-white [&>svg]:w-3.5 [&>svg]:h-3.5': context.checked,
      },

      // Transitions
      'transition-colors',
      'duration-200',
    ],
  }),
  input: {
    class: [
      'peer',

      // Size
      'w-full ',
      'h-full',

      // Position
      'absolute',
      'top-0 left-0',
      'z-10',

      // Spacing
      'p-0',
      'm-0',

      // Shape
      'opacity-0',
      'rounded',
      'outline-none',
      'border',

      // Misc
      'appearance-none',
      'cursor-pointer',
    ],
  },
  icon: ({ state }: Record<string, any>) => ({
    class: [
      // Size
      'w-3.5',
      'h-3.5',

      // Colors
      {
        'text-primary': state.d_indeterminate,
      },

      // Transitions
      'transition-all',
      'duration-200',
    ],
  }),
};
